// extracted by mini-css-extract-plugin
export var downArrow = "_9f-0";
export var infoTooltipIcon = "_9f-3";
export var label = "_9f-1";
export var optionCard = "_9f-4";
export var upArrow = "_9f-2";